<!-- ⚠️ NZSC-3664: 이 라우트는 naezipscan-web-core(Next.js)가 서빙 중 (2026-08-23 컷오버).
  이 파일은 롤백 안전망이라 삭제 금지 — 여기를 고쳐도 유저에게 안 보인다. 화면 수정은 web-core 에서.
  정본 = playbook work-contexts/20260803-007, 감시 = web-core scripts/check-web-sync.py -->
<template>
  <div>
    <article class="main monthly_landing_wrapper">
      <!-- NZSC-3222: 전월세(월세/반전세) 광고 유입 전용 랜딩. 본문은 풀폭 이미지(동적부 없음). -->
      <div class="monthly_landing_imgs">
        <!-- 소구점 이미지 1~5 -->
        <img
          v-for="i in 5"
          :key="`landing-monthly-top-${i}`"
          class="monthly_landing_img"
          :src="`${MONTHLY_LANDING_BASE}/landing_%20monthly${i}.svg`"
          loading="lazy"
        />

        <!-- 인라인 스코어 카드 (Figma 674:433~441) — 5·6섹션 사이. 클릭 시 리포트 발급 퍼널 -->
        <div class="monthly_landing_cta">
          <div class="mlc_top">
            <img
              class="mlc_score"
              src="@/assets/images/source/etc/score.svg"
              alt="score"
            />
            <p class="mlc_desc">내가 계약하려는 집의<br />안전도 점수도 확인해 보세요</p>
          </div>
          <div
            class="mlc_btn"
            @click="fnAnalyze('score_card_btn')"
          >
            <p>우리 집 점수 확인하기</p>
          </div>
        </div>

        <!-- 소구점 이미지 6~7 -->
        <img
          v-for="i in [6, 7]"
          :key="`landing-monthly-bottom-${i}`"
          class="monthly_landing_img"
          :src="`${MONTHLY_LANDING_BASE}/landing_%20monthly${i}.svg`"
          loading="lazy"
        />
      </div>

      <!-- 고정 하단 CTA — AnalyzeHome 표준 패턴 재사용(fixed_content > main_landing_btn > btn_skyblue_scan).
           말풍선만 Figma 674:720 "문구 변경"(업계 최초 1:1 담당자 배정)으로 교체. -->
      <article class="fixed_content">
        <div
          class="main_landing_btn"
          :style="customHeight"
        >
          <div class="monthly_landing_bubble">
            <span>업계 최초 1:1 담당자 배정 👀</span>
          </div>
          <div
            class="btn_skyblue_scan"
            @click="fnAnalyze('scan_btn')"
          >
            <span>우리집 위험도 스캔하기</span>
          </div>
        </div>
      </article>
    </article>
  </div>
</template>

<script>
import "@/assets/css/common.css";
import { mapActions, mapMutations } from "vuex";

export default {
  name: "MonthlyLandingView",
  data() {
    return {
      // 파일명에 공백이 있어 %20 인코딩 필수
      MONTHLY_LANDING_BASE: "https://image.kredatalab.com/landing/monthly",
    };
  },
  computed: {
    // AnalyzeHome 과 동일 — GNB 높이만큼 CTA를 띄움
    customHeight() {
      return { "--ctaHeight": "73px" };
    },
  },
  created() {
    this.setFooterBoolState(true);
    this.$track_view("monthly_landing", "page");
  },
  mounted() {
    this.fnInit();
  },
  methods: {
    ...mapActions(["acPayStatus"]),
    ...mapMutations(["setFooterBoolState"]),
    fnInit() {
      this.acPayStatus(false);
    },
    fnAnalyze(target) {
      // 신규 표준 API(NZSC-3077). $mixpanel_track 은 deprecated라 미사용. 클릭 자체는 autocapture로도 잡힘.
      // 인라인 스코어카드(score_card_btn) vs 하단 플로팅 CTA(scan_btn) 구분.
      this.$track_click(target || "scan_btn");
      // AnalyzeHome.fnAnalyze 와 동일하게 리포트 발급 퍼널 진입점으로 이동
      this.$router.push("/analyze/type");
    },
  },
};
</script>

<style scoped>
.monthly_landing_imgs {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0;
  /* 인라인 카드 주변 갭이 이미지 섹션(landing_monthly5) 배경과 같도록 */
  background: #f5f7fa;
  /* 마지막 섹션이 고정 CTA/GNB에 가리지 않도록 하단 여백 */
  padding: 0 0 180px 0;
  line-height: 0;
}
.monthly_landing_img {
  display: block;
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0;
  vertical-align: bottom;
  object-fit: contain;
}

/* 인라인 스코어 카드 (Figma 674:433~441) — 결제화면 amount_monthly_cta_score 와 동일 디자인 패밀리 */
.monthly_landing_cta {
  /* Figma: 위 24 / 아래 70, 좌우 24(섹션 카드 인셋 정렬) */
  margin: 24px 24px 70px 24px;
  background: #ffffff;
  border: 1.5px solid #50bfff;
  border-radius: 16px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.09);
  padding: 20px;
  line-height: normal;
}
.monthly_landing_cta .mlc_top {
  display: flex;
  align-items: center;
  gap: 14px;
}
.monthly_landing_cta .mlc_score {
  width: 54px;
  height: 54px;
  flex-shrink: 0;
}
.monthly_landing_cta .mlc_desc {
  margin: 0;
  color: #000000;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
}
.monthly_landing_cta .mlc_btn {
  margin-top: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px 16px;
  border-radius: 8px;
  background-image: linear-gradient(71.26deg, #50bfff 33.94%, #2181ff 77.36%);
  cursor: pointer;
}
.monthly_landing_cta .mlc_btn p {
  margin: 0;
  color: #ffffff;
  font-size: 15px;
  font-weight: 600;
  line-height: 20px;
}

/* 버튼 행 — AnalyzeHome .main_landing_btn 표준값 (해당 스타일이 이 라우트엔 로드 안 돼 직접 정의) */
.main_landing_btn {
  text-align: center;
  margin-bottom: var(--ctaHeight);
  display: inline-flex;
  justify-content: center;
  align-content: center;
  width: 85%;
  position: relative;
  height: auto;
}
/* 표준 스캔 버튼 — AnalyzeHome .btn_skyblue_scan 값 그대로 */
.btn_skyblue_scan {
  margin-top: 4px;
  width: 100%;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #5087ff;
  cursor: pointer;
  border-radius: 20px;
  color: #fff;
  font-size: 18px;
  font-weight: 700;
  line-height: 30px;
}

/* 말풍선 (Figma 674:720) — 표준 버튼 위에 absolute. 좌측 정렬 + 바닥 좌측 꼬리 */
.monthly_landing_bubble {
  position: absolute;
  /* 버튼 위 중앙 정렬, 꼬리가 버튼 상단에 겹치도록 낮게 */
  left: 50%;
  transform: translateX(-50%);
  bottom: calc(100% - 6px);
  padding: 9px 16px;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.16);
}
.monthly_landing_bubble span {
  color: #121212;
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
  white-space: nowrap;
}
/* 꼬리 — 버블 하단 중앙, 버튼 위로 겹침 */
.monthly_landing_bubble::after {
  content: "";
  position: absolute;
  bottom: -4px;
  left: 50%;
  width: 12px;
  height: 12px;
  background: #ffffff;
  transform: translateX(-50%) rotate(45deg);
  box-shadow: 2px 2px 4px 0px rgba(0, 0, 0, 0.05);
}
</style>
